import { Box, Flex, Input, Pagination, Text, Avatar } from '@sparrowengg/twigs-react'
import React, { useState } from 'react'
import { SearchIcon, RefreshIcon } from "@sparrowengg/twigs-react-icons";
import { useDispatch } from 'react-redux';
import { clearEnvironment } from '../redux/environmentSlice';

// S3 URL for SS Logo
const SS_LOGO_URL = '/assets/SSLogo.png';

function TopNav({ activePage, setActivePage, paginationInfo, handleSearch, currentEnvironment, onRefresh }) {
  const { totalItems, itemsPerPage, currentPage } = paginationInfo;
  const startIndex = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, totalItems);
  const [searchData, setSearchData] = useState('');
  const dispatch = useDispatch();

  return (
    <Flex
      justifyContent="space-between"
      css={{
        width: '100%',
        padding: '$4 $12',
        height: '60px',
        alignItems: 'center',
        boxSizing: 'border-box',
        '@media (max-width: 768px)': {
          padding: '$4 $2',
        },
        background: '$white',
        borderBottom: '1px solid $black200',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        'p': {
          fontFamily: 'DM Sans'
        }
      }}
    >
      <Flex css={{
        height: '100%',
        alignItems: 'center',
        flex: 1,
        gap: '$4'
      }}>
        <Box 
          as="button"
          onClick={() => dispatch(clearEnvironment())}
          css={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0
          }}
        >
          <Avatar
            src={SS_LOGO_URL}
            alt="SS logo"
            size="md"
            css={{
              border: '2px solid $primary100',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Box css={{
            width: '1px',
            height: '$6',
            background: '$black200',
            margin: '0 $4'
          }} />
          <Text size="lg" css={{
            lineHeight: '$lg',
            fontWeight: 'bold',
            color: '#000',
            letterSpacing: '-0.02em'
          }}>
            SparrowConnect
          </Text>
          {currentEnvironment && (
            <Box css={{
              backgroundColor: '$primary500',
              color: '$white',
              padding: '$2 $2',
              borderRadius: '$sm',
              fontSize: '$xs',
              fontWeight: 'bold',
              marginLeft: '$6',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontFamily: 'DM Sans'
            }}>
              {currentEnvironment}
            </Box>
          )}
        </Box>
      </Flex>

      <Flex css={{
        height: '40px',
        width: '40%',
        flex: 1.5,
        'p': {
          fontFamily: 'DM Sans'
        }
      }}>
        <Input
          id="ss-sms-search-input"
          leftIcon={<SearchIcon />}
          placeholder="Search messages..."
          value={searchData}
          onChange={(event) => {
            handleSearch(event.target.value);
            setSearchData(event.target.value);
          }}
          css={{
            width: '100%',
            height: '100%',
            '&:focus': {
              borderColor: '$primary500',
              boxShadow: '0 0 0 2px $primary100'
            },
            'p': {
              fontFamily: 'DM Sans !important',
            }
          }}
          size="md"
        />
      </Flex>

      <Flex 
        alignItems="center" 
        css={{
          flex: 1,
          gap: '$4',
          justifyContent: 'flex-end'
        }}
      >
        {onRefresh && (
          <Box
            as="button"
            onClick={onRefresh}
            css={{
              padding: '$2',
              border: '1px solid $black200',
              borderRadius: '$md',
              backgroundColor: '$white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                backgroundColor: '$black50',
                borderColor: '$primary300'
              },
              '&:active': {
                backgroundColor: '$black100'
              }
            }}
            title="Refresh data"
          >
            <RefreshIcon size={16} />
          </Box>
        )}
        <Text css={{
          color: '$black600',
          fontSize: '$sm',
          fontWeight: 'medium'
        }}>
          {totalItems === 0 ? '0' : `${startIndex}-${endIndex}`} of {totalItems}
        </Text>
        <Pagination
          activePage={activePage}
          itemsPerPage={itemsPerPage}
          total={totalItems}
          size="sm"
          onChange={(event, page) => setActivePage(page)}
          css={{
            '& button': {
              '&:hover': {
                background: '$primary100'
              },
              '&[data-active="true"]': {
                background: '$primary500',
                color: '$white'
              }
            }
          }}
        />
      </Flex>
    </Flex>
  )
}

export default TopNav